import { HttpInterceptorFn } from '@angular/common/http';

export const clientHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const request = req.clone({
    setHeaders: {
      client: 'Timer',
    },
  });

  return next(request);
};
